import { AuthService } from 'src/app/services/api/auth.service';
import { Component } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { RouteLinks } from '../../config/routes.config';
import { Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';

@Component({
  selector: 'app-zorro-layout',
  templateUrl: './zorro-layout.component.html',
  styleUrls: ['./zorro-layout.component.scss'],
})
@UntilDestroy()
export class ZorroLayoutComponent {
  constructor(
    private router: Router,
    private authService: AuthService,
    private message: NzMessageService
  ) {}
  isCollapsed = false;
  routeLinks = RouteLinks;
  name: string = 'Default Title';

  userName: string = '';
  userAvatar: string = '';

  onLogout() {
    this.authService.logout();
    this.message.success('Logout Success');
  }
  log(): void {
    console.log('click dropdown button');
  }
}
